define('shared/util/path/ResolverFactory',[
    'shared/lib/ctor',
    'shared/lib/RSVP'
], function (
    ctor,
    RSVP
) {
    'use strict';

    var resolvers;
    var location = window.location;

    function SitePathResolver(path) {
        this.path = path;
    }

    SitePathResolver.applicable = function(path) {
        return typeof this.basePath === 'string' ? path.indexOf(this.basePath) === 0 : this.basePath.test(path);
    };

    SitePathResolver.prototype.sub = function(options) {
        var me = this;

        return me.site(options)
            .then(function(sitePath){
                return me.path.replace(sitePath, '/');
            });
    };

    SitePathResolver.prototype.site = function(options) {
        var me = this;

        return new RSVP.Promise(function(resolve){
            var result = me.constructor.basePath.exec(me.path);
            result = result && result[0];
            if (options && options.quirky) {
                result = result.replace(/\/$/, '');
            }
            else
            if (result.charAt(result.length - 1) !== '/') {
                result += '/';
            }
            resolve(result);
        });
    };

    SitePathResolver.prototype.prop = function(propName) {
        var me = this;

        if (propName == null || typeof propName !== 'string') {
            return RSVP.reject('propName must be a string');
        }

        propName = propName.toLowerCase();

        if (me.constructor.index == null || typeof me.constructor.index[propName] != 'number') {
            return RSVP.reject(propName + ' cannot be found from path');
        }

        var regexIndex = me.constructor.index[propName];

        return new RSVP.Promise(function(resolve, reject){
            var result = me.constructor.basePath.exec(me.path);
            if (result == null || result[regexIndex] == null) {
                reject(propName + ' cannot be found from path');
                return;
            }
            else {
                resolve(result && result[regexIndex]);
                return;
            }
        });
    };

    var B2CAuthorSitePathResolver = ctor(function () {
    }).inherit(SitePathResolver);
    B2CAuthorSitePathResolver.basePath = /^\/content\/(englishtown|efec)\/(\w\w\w?)\/(\w\w)(?=\/|\.\w*?$)/;
    B2CAuthorSitePathResolver.index = {
        language: 3,
        market: 2
    };
    B2CAuthorSitePathResolver.applicable = function(path) {
        return SitePathResolver.applicable.call(this, path);
    };

    var B2CCommonSiteAuthorSitePathResolver = ctor(function () {
    }).inherit(SitePathResolver);
    B2CCommonSiteAuthorSitePathResolver.basePath = /^\/content\/(openemailenglish|cursoinglesgratis)(?=\/|\.\w*?$)/;
    B2CCommonSiteAuthorSitePathResolver.index = {
    };
    B2CCommonSiteAuthorSitePathResolver.applicable = function(path) {
        return SitePathResolver.applicable.call(this, path);
    };

    var B2CAuthorMasterSitePathResolver = ctor(function () {
    }).inherit(SitePathResolver);
    B2CAuthorMasterSitePathResolver.basePath = /^\/content\/englishtown-masters\/(\w*?)(?=\/|\.\w*?$)/;
    B2CAuthorMasterSitePathResolver.index = {
        market: 1
    };
    B2CAuthorMasterSitePathResolver.applicable = function(path) {
        return SitePathResolver.applicable.call(this, path);
    };

    var B2CLiveSitePathResolver = ctor(function () {
    }).inherit(SitePathResolver);
    B2CLiveSitePathResolver.basePath = /^\/(\w*?)-(\w*?)\//;
    B2CLiveSitePathResolver.index = {
        language: 1,
        market: 2
    };
    B2CLiveSitePathResolver.applicable = function(path) {
        return path.indexOf('/content/') !== 0 &&
            SitePathResolver.applicable.call(this, path);
    };

    var B2CLiveCustomDomainSitePathResolver = ctor(function () {
    }).inherit(SitePathResolver);
    B2CLiveCustomDomainSitePathResolver.basePath = /^\//;
    B2CLiveCustomDomainSitePathResolver.index = {
    };
    B2CLiveCustomDomainSitePathResolver.applicable = function(path) {
        return B2CLiveSitePathResolver.basePath.exec(path) == null &&
            SitePathResolver.applicable.call(this, path);
    };

    resolvers = [
        B2CAuthorMasterSitePathResolver,
        B2CAuthorSitePathResolver,
        B2CCommonSiteAuthorSitePathResolver,
        B2CLiveSitePathResolver,
        B2CLiveCustomDomainSitePathResolver
    ];

    function ResolverFactory(pathname) {
        this.path = pathname || location.pathname;
    }

    ResolverFactory.prototype.produce = function() {
        var path = this.path;
        var resolver;

        for(var i = 0; i < resolvers.length; i++) {
            if (resolvers[i].applicable(path)) {
                resolver = new resolvers[i](path);
                break;
            }
        }

        return resolver;
    };

    return ResolverFactory;
});

